import { connect } from "vuex-connect";
// import log from 'loglevel';
import { AlertDialog } from "../../../components";

export default connect({
  stateToProps: {
    alertDialogState: state => state.common.alertDialogState
  },
  actionsToProps: {
    closeAlertDialog: (dispatch, value) =>
      dispatch("common/closeAlertDialog", value)
  },
  mutationsToProps: {
    resetError: "common/setError"
  }
})(AlertDialog.name, AlertDialog);
